import { render, staticRenderFns } from "./CreatePriceRules.vue?vue&type=template&id=85142b3a"
import script from "./CreatePriceRules.vue?vue&type=script&lang=js"
export * from "./CreatePriceRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports